import ComponentCard from "components/Common/ComponentCard";
import PrimaryButton from "components/Common/PrimaryButton";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { buttonCode } from "./buttonCode";
import AllUsage from "components/AllUsage";

const ButtonComponentCard = ({
  data,
  setButtonState,
  setButtonSize,
  showModal,
  isLoading,
  tokenDataType,
  setSelectedTab,
}) => {
  return (
    <div key={data.id} className="plt-content-wrapper">
      <div className="plt-content-wrapper-block dis-mb-24">
        <h6 className="plt-contents-head plt-heading-sm plt-font-color-primary dis-mb-8">
          {data.title}
        </h6>
        <p className="plt-contents-desc plt-body-md plt-font-color-secondary font-weight-400">
          {data.description}
        </p>
      </div>
      <ComponentCard
        edit={true}
        showCode={true}
        htmlContent={buttonCode(data)}
        editClick={() => {
          if (data?.title === "disabled") {
            // setButtonSize("large");
            setButtonState("Disabled");
          } else {
            setButtonSize((prev) => (prev = data?.title?.toLowerCase()));
          }
          // buttonSize &&
          showModal(
            data.variant,
            data.size,
            tokenDataType,
            data.disabled,
            data.fluid,
            data.prefixIcon,
            data.suffixIcon,
            data.icon,
            data.iconOnly,
            data.text
          );
        }}
      >
        {isLoading ? (
          <Skeleton height={36} width={150} />
        ) : (
          <PrimaryButton
            prefixIcon={data.prefixIcon}
            suffixIcon={data.suffixIcon}
            size={data.size}
            variant={data.variant}
            disabled={data.disabled}
            icon={data.icon}
            iconOnly={data.iconOnly}
            fluid={data.fluid}
            text={data.text}
          />
        )}
      </ComponentCard>
      <AllUsage setSelectedTab={setSelectedTab} />
    </div>
  );
};

export default ButtonComponentCard;
